import '../libs/glider/glider.min.js'

// manage the brightness of the header
function manageBrightness( textbrightness ) {
	// grab logo for if we need to change brightness
	var header = document.querySelector( '.header' );
	if ( textbrightness == 'light' && !header.classList.contains( 'light' ) ) {
		header.classList.remove( 'dark' );
		header.classList.add( 'light' );
	}
	if ( textbrightness == 'dark' && !header.classList.contains( 'dark' ) ) {
		header.classList.remove( 'light' );
		header.classList.add( 'dark' );
	}
}

class Carousel {
	constructor( el ) {
		if ( !el ) return false;

		this.currentSlide = 0;
		this.buttons = [];


		// is the target a string
		if ( typeof el === 'string' ) {
			this.wrapper = document.querySelector( el );
		}

		// Check if the variable is a DOM element
		else if ( el instanceof Element ) {
			this.wrapper = el;
		}

		// get all the slides
		this.slides = this.wrapper.querySelectorAll( '.slide' );

		// Bail if we have less then 2 slides
		if ( this.slides.length < 2 ) return;

		// Create the controls
		this.controlWrapper = document.createElement( 'div' );
		this.controlWrapper.classList.add( 'carousel-controller' );
		this.wrapper.insertBefore( this.controlWrapper, this.wrapper.querySelector( '.carousel' ) );

		// add the play / pause button?
		if ( this.wrapper.classList.contains( 'autoplay' ) ) {
			this.playPauseButton = document.createElement( 'button' );
			this.playPauseButton.innerHTML = '<span class="play">⏵︎</span><span class="pause">⏸︎</span>';
			this.playPauseButton.setAttribute( 'aria-label', 'Animate Carousel' );
			this.playPauseButton.setAttribute( 'aria-pressed', 'true' );
			this.playPauseButton.classList.add( 'carousel-button' );
			this.playPauseButton.addEventListener( 'click', () => this.playPauseButtonClick() );
			this.controlWrapper.appendChild( this.playPauseButton );
		}

		// create a holder for the slide indicators
		this.buttonWrapper = document.createElement( 'div' );
		this.buttonWrapper.classList.add( 'carousel-buttons' );
		this.buttonWrapper.setAttribute( 'role', 'tablist' );
		this.controlWrapper.appendChild( this.buttonWrapper );

		// add the indicator
		this.counterIndicator = document.createElement( 'span' );
		this.counterIndicator.classList.add( 'counter' );
		this.counterIndicator.setAttribute( "role", "presentation" );
		this.setIndicator( 0 );
		this.buttonWrapper.appendChild( this.counterIndicator );


		// create the slide buttons
		this.slides.forEach( ( slide, index ) => {

			// set an ID for each slide
			slide.id = "slide" + index;

			let button = document.createElement( 'button' );
			button.textContent = index + 1;
			if ( slide.dataset.trackTitle ) {
				button.setAttribute( "aria-label", "Slide " + ( index + 1 ) + ": " + slide.dataset.trackTitle );
			} else {
				button.setAttribute( "aria-label", "Slide " + ( index + 1 ) );
			}

			button.classList.add( 'carousel-button' );

			button.setAttribute( 'role', 'tab' );
			button.setAttribute( 'selected', 'false' );
			button.setAttribute( 'aria-controls', 'slide' + index );

			if ( 0 == index ) {
				button.classList.add( 'active' );
				button.setAttribute( 'selected', true );
			}

			// make it so a keyboard user cant get to the none active slides or tabs
			if ( index > 0 ) {
				button.setAttribute( 'tabindex', '-1' );
				slide.setAttribute( 'tabindex', '-1' );
			}

			button.addEventListener( 'click', () => this.slideButtonSelected( index ) );
			button.addEventListener( "keydown", ( event ) => this.onKeydown( index, event ) );

			this.buttonWrapper.appendChild( button );

			this.buttons.push( button );

		} );


		// Create the Glider object
		this.glider = new Glider( this.wrapper.querySelector( '.carousel' ), {
			slidesToShow: 1
		} );


		// Autoplay?
		this.timer = null;
		if ( this.wrapper.classList.contains( 'autoplay' ) ) {
			this.play();
		}


		// keyboard or mouse focus on the parent or children
		this.wrapper.querySelector( '.carousel' ).addEventListener( 'mouseover', () => this.focusIn() );
		this.wrapper.querySelector( '.carousel' ).addEventListener( 'focusin', () => this.focusIn() );

		// keyboard of mouse blur
		this.wrapper.querySelector( '.carousel' ).addEventListener( 'mouseout', () => this.focusOut() );
		this.wrapper.querySelector( '.carousel' ).addEventListener( 'focusout', () => this.focusOut() );

	}

	slideButtonSelected( index ) {
		// stop the autoplay
		this.stop();

		// show the requested slide
		this.showSlide( index );
	}

	onKeydown( index, event ) {
		let flag = false;

		switch ( event.key ) {
			case "ArrowLeft":
				if ( index > 0 ) {
					this.stop();
					this.showSlide( index - 1, true );
				}
				flag = true;
				break;

			case "ArrowRight":
				if ( index < this.slides.length - 1 ) {
					this.stop();
					this.showSlide( index + 1, true );
				}
				flag = true;
				break;

			case "Home":
				this.stop();
				this.showSlide( 0, true );
				flag = true;
				break;

			case "End":
				this.stop();
				this.showSlide( this.slides.length - 1, true );
				flag = true;
				break;

			default:
				break;
		}

		if ( flag ) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	setIndicator( index, focus = false ) {
		// turn the old indicator off
		this.buttons.forEach( ( i ) => {
			i.setAttribute( 'selected', false );
			i.classList.remove( 'active' );
			i.setAttribute( 'tabindex', -1 );
		} );

		// mark the current one as active
		if ( this.buttons.length ) {
			this.buttons[ index ].classList.add( 'active' );
			this.buttons[ index ].setAttribute( 'selected', true );
			this.buttons[ index ].removeAttribute( 'tabindex' );
		}

		// focus on the new tab if requested
		if ( focus ) {
			this.buttons[ index ].focus();
		}


		// calculate the indicator offset and set it. 
		let offset = 0;
		if ( this.playPauseButton ) {
			offset = 1;
		}
		this.counterIndicator.setAttribute( 'style', 'transform: translateY(' + ( ( index + offset ) * 100 ) + '%)' );

		// get textbrightness of current image or ytvideo, and apply it to header
		let textbrightness = 'dark'; // default
		let mediaElement = this.slides[ index ].querySelector( 'img, video' );
		if ( mediaElement.classList.contains( 'light' ) ) {
			textbrightness = 'light'
		}
		manageBrightness( textbrightness );

	}

	showSlide( index, focus = false ) {
		// make the current slide not keyboard accessible
		this.slides[ this.currentSlide ].setAttribute( 'tabindex', -1 );
		this.slides[ index ].removeAttribute( 'tabindex' );
		// tell glider to advance to the slide
		this.glider.scrollItem( +index );

		// set the indicator
		this.setIndicator( +index, focus );

		// set the current slide
		this.currentSlide = index;

	}

	playPauseButtonClick() {
		if ( this.playing ) {
			this.stop();
		} else {
			this.nextSlide();
			this.play();
		}
	}

	play() {
		this.stop(); // Stop any existing interval
		this.timer = setInterval( () => this.nextSlide(), 5000 );
		if ( this.playPauseButton ) {
			this.playPauseButton.setAttribute( 'aria-pressed', 'true' )
		}
		this.playing = true;
	}

	stop() {
		this.playing = false;
		if ( this.playPauseButton ) {
			this.playPauseButton.setAttribute( 'aria-pressed', 'false' )
		}
		clearInterval( this.timer );
	}

	pause() {
		clearInterval( this.timer );
	}

	nextSlide() {
		this.currentSlide = ( this.currentSlide + 1 ) % this.slides.length;
		this.showSlide( this.currentSlide );
	}

	focusIn() {
		this.pause();
	}

	focusOut() {
		this.play();
	}

}

// Start the hunt for something to turn into a carousel... once the dom is ready and such
window.addEventListener( 'DOMContentLoaded', function ( e ) {
	new Carousel( '.carousel-wrapper' );
} );
